/* ------------------------------------ - ----------------------------------- */
import {UserPropsPlacehoderPropType, UserPropsPlaceholderLabel} from '@global-data';

import {ObjectDataLabel} from './types';

export type ObjectBuildType = Record<ObjectDataLabel, UniquePlaceholderTemplateString<UniquePlaceholderDataSource>>; // the output object export type

export const UniquePlaceholderDataSource = {
	meta_tag: 'meta_tag',
	user_info: 'user_info',
	constant: 'const',
} as const;
export type UniquePlaceholderDataSource = (typeof UniquePlaceholderDataSource)[keyof typeof UniquePlaceholderDataSource];

export type UniquePlaceholderTemplateString<Source extends UniquePlaceholderDataSource = UniquePlaceholderDataSource, Key extends string = string> =
	| `<<${Source}::${Key}>>`
	| `<<${Source}::${Key}::${string}>>`;

export function isUniquePlaceholderTemplateString(value: string): value is UniquePlaceholderTemplateString {
	return /^<<.+::[^>]+>>$/.test(value);
}

export type UniquePlaceholderData = {
	source: UniquePlaceholderDataSource;
	key: string;
	label?: string;
};

export function parseUniquePlaceholderTemplateString<Source extends UniquePlaceholderDataSource = UniquePlaceholderDataSource, Key extends string = string>(
	templateString: UniquePlaceholderTemplateString,
): UniquePlaceholderData {
	const regex = /<<([^:]+)::([^:]+)(?:::(.+?))?>>/;
	const match = templateString.match(regex);
	if (!match) throw new Error('Invalid UniquePlaceholderTemplateString format');
	const [, source, key, label] = match;
	return {
		source: source as Source,
		key: key as Key,
		label: label || '',
	};
}

/* ------------------------------------ - ----------------------------------- */

export type ObjectBuildAvailablePlaceholder<T extends string = string> = {
	source: UniquePlaceholderDataSource;
	key: T;
	label: string;
	icon?: string;
};

export function getDefaultAvailablePlaceholdersForSource(source: UniquePlaceholderDataSource, translateFn?: (label: string) => string): ObjectBuildAvailablePlaceholder[] {
	switch (source) {
		case UniquePlaceholderDataSource.user_info:
			return Object.keys(UserPropsPlacehoderPropType).map(key => ({
				key,
				label: translateFn ? translateFn(UserPropsPlaceholderLabel[key]) : UserPropsPlaceholderLabel[key],
				source,
			}));
		default:
			return [];
	}
}
